import HeaderWidget from "../../../../common/components/molecule/HeaderWidget/HeaderWidget";
import { useMicroNavigator } from "../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";

export default function SingleLinkPage() {
  const {navigate} = useMicroNavigator();
  return (
    <div>
      <HeaderWidget variant={"dark"} handleBackBtn={() => navigate('list')}>Single Link Page</HeaderWidget>
    </div>
  )
}
